module.exports = __webpack_public_path__ + "img/login_bg.784f769f.png";